import React, {
  FunctionComponent,
  memo,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { _t } from 'app/utils/i18n';

import styles from './TweetColumn.module.scss';
import CardTitle from 'app/components/CardTitle';
import TweetBox from 'app/components/TweetBox';
import { path } from 'app/utils/path';
import { getTweetColumnData } from 'app/Requests';
import SelectInput from 'app/components/Form/Inputs/SelectInput';
import { ReactComponent as SortIcon } from 'app/assets/images/sortIcon.svg';
import NoData from 'app/components/NoData';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { nFormatter } from 'app/utils/numbersFormater';
import { v4 as uuid } from 'uuid';
import { useQuery, useQueryClient } from 'react-query';
import Loader from 'app/components/Loader';
import AddComment from 'reports/components/AddComment';
import { checkRouteName } from 'app/utils/check-route-name';
import PostBox from 'app/components/PostBox/PostBox';
interface Props {
  type: 'negative' | 'positive' | 'neutral' | 'all';
  hideSort?: boolean;
  customFilters?: any;
  requestUrl: string;
  compId: string;
  setTweetsItems?: any;
  endMessage?: string;
  isInfluencerModule?: any;
  setFilterIsLoading?: any;
  filterIsLoading?: boolean;
  isReport?: boolean;
  hideQuestionmarkIcon?: boolean;
  showWrittenAt?: boolean;
  isTemplate?: boolean;
  data?: any;
  reportState?: any;
  chartId?: string;
  tabName?: string;
  without_translate?: boolean;
  stopScroll?: boolean;
  showRegrab?: boolean;
  hideSliderFormPostCard?: boolean;
  showFavorite?: boolean;
  postDetailsUrl?: string;
}

type Response = {
  total_record: number;
  total_page: number;
  records: any[] | null;
};

const options = [
  {
    label: _t('basic:ascending'),
    value: 'asc',
  },
  {
    label: _t('basic:descending'),
    value: 'desc',
  },
];
const TweetColumn: FunctionComponent<Props> = ({
  type,
  hideSort,
  customFilters,
  requestUrl,
  compId,
  setTweetsItems,
  endMessage,
  isInfluencerModule,
  setFilterIsLoading,
  filterIsLoading,
  isReport,
  hideQuestionmarkIcon,
  isTemplate,
  showWrittenAt,
  data,
  reportState,
  chartId,
  tabName,
  without_translate,
  stopScroll,
  showRegrab,
  hideSliderFormPostCard,
  showFavorite,
  postDetailsUrl,
}) => {
  const [items, setItems] = useState([]);
  const [filters, setFilters] = useState(() => ({
    limit: 10,
    ...customFilters,
  }));
  const [page, setPage] = useState(data ? 2 : 1);
  const [isPage, setIsPage] = useState(false);
  const isVideo = requestUrl?.includes('videos');

  const [response, setResponse] = useState<Response>({
    total_record: data ? data?.total_record : 0,
    total_page: data ? data?.total_page : 0,
    records: data ? data?.records : null,
  });
  const [noData, setNoData] = useState<boolean>(false);
  const handleChangeFilters = () => (option: any) => {
    setPage(1);
    setFilters((prevFilters: any) => ({
      ...prevFilters,
      type_of_sort: option.value,
    }));
  };

  const queryClient = useQueryClient();

  const { isLoading } = useQuery(
    [
      'getTweetColumnData',
      {
        slug: requestUrl,
        category: type,
        body: {
          ...filters,
          ...customFilters,
          page,
        },
      },
    ],
    getTweetColumnData,
    {
      onSuccess: (result) => {
        if (!isPage) {
          setItems(result?.payload?.records);
          if (filterIsLoading && !stopScroll) {
            window.scrollTo(0, document.body.clientHeight / 1.5);
            setPage(1);
          }
          setFilterIsLoading?.(false);
        } else {
          setItems((old: any) => {
            return [...old, ...result?.payload?.records] as any;
          });
          setIsPage(false);
        }
        setTweetsItems &&
          setTweetsItems((old: any) => {
            return [...old, ...result?.payload?.records];
          });

        if (result?.payload?.records?.length == 0) {
          setNoData(true),
            setResponse({
              records: result?.payload?.records,
              total_record: result?.payload?.total_record,
              total_page: result?.payload?.total_page,
            });
        } else {
          setResponse({
            ...response,
            records: result?.payload?.records,
            total_record: result?.payload?.total_record,
            total_page: result?.payload?.total_page,
          });
        }
      },

      staleTime: 0,
      refetchOnMount: true,
      cacheTime: 0,
      keepPreviousData: false,
      refetchOnReconnect: true,
    },
  );
  useMemo(() => {
    setPage(1);
    if (!isLoading && filterIsLoading) setFilterIsLoading?.(false);
  }, [customFilters]);
  useEffect(() => {
    return () => {
      queryClient.removeQueries([
        'getTweetColumnData',
        {
          slug: requestUrl,
          category: type,
          body: { ...filters, ...customFilters, page },
        },
      ]);
    };
  }, []);

  const newdataItems = data ? data?.records : items;
  const stopDrag = isReport || isTemplate || checkRouteName('compare-hashtags');
  const fetchMoreData = async () => {
    if (page < response.total_page) {
      setPage(newdataItems.length / 10 + 1);
      setIsPage(true);
    }
  };
  const isTweet = [
    'HASHTAG',
    'TWEET',
    'TWEETS',
    'REPLIES',
    'QUOTES',
    'COMMENTS',
    'POSTS_INSTA',
  ];

  const SubCard = ({ tweet, provided = {} }: any) => {
    return (
      <div
        ref={provided?.innerRef}
        {...provided?.draggableProps}
        {...provided?.dragHandleProps}
        data-testid={`tweet-box-${uuid()}`}
      >
        <PostBox
          data={tweet}
          columnType={type}
          isTemplate={isTemplate!}
          compId={tweet?.id}
          isReport={isReport!}
          tabName={tabName}
          hideSliderFormPostCard={hideSliderFormPostCard}
          showFavorite={showFavorite}
          postDetailsUrl={postDetailsUrl}
        />
        {/*           <TweetBox
            key={tweet?.id}
            data={tweet}
            tweetType={type}
            showPlatformIcon
            isTemplate={isTemplate}
            compId={tweet?.id}
            showWrittenAt={showWrittenAt}
            isReport={isReport}
            navigationUrl={
              tabName === 'POSTS_INSTA'
                ? `${path.posts.INSTAGRAM_POSTS_DETAILS_URI}/${tweet?.id}`
                : undefined
            }
            isTweets={!!isTweet?.filter((i) => i === tabName)?.length}
            isInstagram={tabName === 'COMMENTS' || tabName === 'POSTS_INSTA'}
            showRegrab={showRegrab}
          /> */}
      </div>
    );
  };
  const Card = ({ provided = {} }: any) => {
    return (
      <div
        ref={stopDrag ? null : provided?.innerRef}
        style={{ height: '100%' }}
      >
        {noData && newdataItems.length === 0 ? (
          <NoData />
        ) : (
          response.records && (
            <div className={`columnContent ${type} tweetBox`}>
              <InfiniteScroll
                dataLength={newdataItems.length}
                next={isReport || isTemplate ? ({} as any) : fetchMoreData}
                hasMore={page < response.total_page}
                scrollableTarget={isReport || isTemplate ? '' : 'scrollableDiv'}
                endMessage={
                  <p className={styles.textCenter}>
                    <b data-testid="no-more-holder">
                      {endMessage
                        ? endMessage
                        : tabName &&
                            tabName !== 'REPLIES' &&
                            tabName !== 'QUOTES'
                          ? _t(
                              `influencers:influencer_no_${tabName.toLocaleLowerCase()}`,
                            )
                          : _t('influencers:influencer_no_tweets')}
                    </b>
                  </p>
                }
                loader={
                  response.total_record > newdataItems.length &&
                  !isReport &&
                  !isTemplate ? (
                    <h4 className={styles.textCenter}>
                      <b>
                        {_t(
                          isVideo || tabName === 'TIKTOK'
                            ? 'basic:we_are_getting_more_videos'
                            : tabName === 'POSTS' || tabName === 'POSTS_INSTA'
                              ? without_translate
                                ? 'basic:we_are_getting_more_posts'
                                : 'basic:we_are_translating_more_posts'
                              : tabName === 'COMMENTS'
                                ? without_translate
                                  ? 'basic:we_are_getting_more_comments'
                                  : 'basic:we_are_translating_more_comments'
                                : without_translate
                                  ? 'basic:we_are_getting_more_tweets'
                                  : 'basic:we_are_translating_more_tweets',
                        )}
                      </b>
                    </h4>
                  ) : null
                }
                style={{ overflowX: 'hidden' }}
              >
                {newdataItems?.map(
                  (tweet: { id: string | number }, index: number) => {
                    return (
                      <React.Fragment key={uuid()}>
                        {stopDrag ? (
                          <SubCard tweet={tweet} />
                        ) : (
                          <Draggable
                            key={tweet?.id}
                            draggableId={String(tweet?.id)}
                            index={index}
                          >
                            {(provided) => <SubCard {...{ provided, tweet }} />}
                          </Draggable>
                        )}
                        <div style={{ marginBottom: '20px' }}></div>
                      </React.Fragment>
                    );
                  },
                )}
              </InfiniteScroll>
              {/* {response.total_record > items.length ? (
              <h4 className={styles.textCenter}>
                <b>
                  {_t(
                    isVideo
                      ? 'basic:we_are_getting_more_videos'
                      : 'basic:we_are_translating_more_tweets'
                  )}
                </b> 
              </h4>
            ) : null} */}
            </div>
          )
        )}
        {stopDrag ? <></> : provided?.placeholder}
      </div>
    );
  };
  return (
    <div
      className={styles.TweetColumn}
      id={compId}
      data-testid={`column-${type}-holder`}
    >
      {/* Column Title */}
      <div className={styles.columnTit}>
        <div
          className={styles.color_tit}
          data-testid={`column-${type}-title-holder`}
        >
          <div className={`columnColor ${type}`}></div>
          <div
            className={`${styles.editCardTitle} ${
              isReport ? styles.tweetsHeaderReport : ''
            }`}
          >
            <CardTitle
              title={`${_t(
                `trends:${type}${
                  isVideo || tabName === 'TIKTOK'
                    ? '_videos'
                    : tabName && tabName !== 'TWEET' && tabName !== 'ARTICLES'
                      ? `_${tabName.toLocaleLowerCase()}`
                      : tabName === 'TWEET'
                        ? '_tweets'
                        : '_posts'
                }`,
              )} (${nFormatter(response?.total_record)})`}
              compId={compId}
              hideIcon={isReport || hideQuestionmarkIcon}
            />
          </div>
        </div>
        {!hideSort && (
          <div
            className={styles.select_input}
            data-testid={`column-${type}-sort-holder`}
          >
            <SelectInput
              name="sort_by_date"
              placeholder={_t('basic:sortBy_date')}
              options={options}
              icon={<SortIcon />}
              onChange={handleChangeFilters()}
            />
          </div>
        )}
        {isReport && !isTemplate ? (
          <div
            className={styles.select_input}
            data-testid={`column-${type}-comment-holder`}
          >
            <AddComment
              removePosition
              compId={compId}
              {...reportState}
              id={customFilters?.hashtag_id}
              chartId={chartId}
            />
          </div>
        ) : null}
      </div>
      {/* Column Content */}
      {isLoading && page == 1 && !data ? (
        <div className="loader-parent">
          <div data-testid={`column-${type}-loader-holder`}>
            <Loader
              loaderText={_t(
                `influencers:we_are_retrieving_your_translated_${tabName?.toLocaleLowerCase()}`,
              )}
            />
          </div>
        </div>
      ) : stopDrag ? (
        <Card />
      ) : (
        <Droppable droppableId={type} key={uuid()}>
          {(provided) => <Card {...{ provided }} />}
        </Droppable>
      )}
    </div>
  );
};

const MemoizedTweetColumn = memo(TweetColumn);
export default MemoizedTweetColumn;
